<!-- 2024/1/18  CourseOutherInfo -->
<template>
  <div id="CourseOutherInfo">
    <div class="outherCourse">
      <!-- 讲师 -->
      <div
              class="author item"
              v-if="videoInfo_o.speakers && videoInfo_o.speakers.length"
      >
        <h3>讲师</h3>
        <div class="authorMain" v-for="(item, index) in videoInfo_o.speakers" :key="index">
          <img :src="item.avatar" alt=""/>
          <div>
            <span>{{ item.name }}</span>
            <i>{{ item.unit }}</i>
          </div>
        </div>
      </div>
      <div class="related item">
        <h3>相关推荐</h3>
        <template v-if="correlatedCurriculum_o.list.length">
          <ul>
            <li
                    class="relatedList"
                    v-for="(item, index) in correlatedCurriculum_o.list"
                    :key="index"
                    @click="toCourse(item.id)"
            >
              <img :src="item.cover" alt=""/>
              <div>
                <h5>{{ item.name }}</h5>
                <p>
                  <b v-for="(user,index) in item.speakers" @click.stop="toPersonal(user)" :key="index">{{ user.name }}</b>
                </p>
                <i>{{ numFormat_cpu(item.views) }}人观看</i>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <LeftCircleFilled :class="correlatedCurriculum_o.pageNo>1?'active':''" @click="prev_fn"/>
            <RightCircleFilled
                    :class="correlatedCurriculum_o.pageNo<correlatedCurriculum_o.totalPage?'active':''"
                    @click="next_fn"/>
          </div>
        </template>
        <Empty v-else :description="correlatedCurriculum_o.empty_null_text"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { LeftCircleFilled, RightCircleFilled } from "@ant-design/icons-vue";
  import { Empty } from "ant-design-vue";
  import { getCurrentCourses } from "@/api";
  import { numFormat } from "@/utils/methods";
  export default {
    name: "CourseOutherInfo",
    components: {
      LeftCircleFilled,
      RightCircleFilled,
      Empty,
    },
    props: ['videoInfo_o','curriculumId'],
    data() {
      return {
        // 相关课程
        correlatedCurriculum_o: {
          pageNo: 1,
          pageSize: 5,
          totalPage: 0,
          list: [],
          empty_null_text: '暂无推荐',
        },
      }
    },
    computed: {
      numFormat_cpu() {
        return (num) => {
          return numFormat(num);
        };
      },
    },
    methods: {
      // 个人中心
      toPersonal(item){
        if(item.systemUserId){
          let href = '/user-center?profileUserId=' + item.systemUserId
          window.open(href, '_blank');
        }
      },
      // 相关推荐上一个
      prev_fn(){
        this.correlatedCurriculum_o.pageNo = this.correlatedCurriculum_o.pageNo - 1;
        if(this.correlatedCurriculum_o.pageNo<1){
          this.correlatedCurriculum_o.pageNo = 1;
        }
        this.getCurrentCourses_fn();
      },
      // 相关推荐下一个
      next_fn(){
        this.correlatedCurriculum_o.pageNo = this.correlatedCurriculum_o.pageNo + 1;
        if(this.correlatedCurriculum_o.pageNo>this.correlatedCurriculum_o.totalPage){
          this.correlatedCurriculum_o.pageNo = this.correlatedCurriculum_o.totalPage;
        }
        this.getCurrentCourses_fn();
      },
      // 获取相关视频
      getCurrentCourses_fn() {
        getCurrentCourses({
          courseId: this.curriculumId,
          pageNo: this.correlatedCurriculum_o.pageNo,
          pageSize: this.correlatedCurriculum_o.pageSize,
        }).then((res) => {
          if (res.data.code === 1) {
            this.correlatedCurriculum_o.list = res.data.list;
            this.correlatedCurriculum_o.totalPage = res.data.page.totalPage;
          }
        });
      },
      // 跳往相关推荐视频详情
      toCourse(id){
        const routeLink = this.$router.resolve({
          path:  '/pages/coursePlay/coursePlay',
          query: {
            courseId: id
          }
        })
        window.open(routeLink.href, '_blank');
        // this.$router.push('/pages/coursePlay/coursePlay?courseId=' + id);
      },
    },
    mounted() {
      this.getCurrentCourses_fn(); // 获取相关课程
    },
    watch:{
      // 监听路由刷新页面
      $route(n,o){
        if(o.path === n.path){
          this.getCurrentCourses_fn(); // 获取相关课程
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  #CourseOutherInfo{
    flex: 1;
    display: flex;
  }
  .outherCourse {
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;

    .item {
      @extend %defaultBg;
      width: 100%;
      border-radius: 6px;
      padding: 20px 15px;
      transition: all .3s;

      h3 {
        font-size: 20px;
        position: relative;
        padding-left: 10px;

        &::after {
          content: "";
          display: inline-block;
          position: absolute;
          width: 3px;
          height: 16px;
          background: $theme_blue;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          border-radius: 4px;
        }
      }
    }

    .author {
      margin-bottom: 20px;

      .authorMain {
        display: flex;
        margin-top: 16px;

        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: #8a8a8a;
          margin-right: 12px;
          object-fit: cover;
        }

        div {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;

          span {
            font-size: 22px;
          }

          i {
            font-size: 18px;
            color: #707070;
          }
        }
      }
    }

    .related {
      ul {
        display: flex;
        flex-direction: column;
        margin-top: 16px;
        height: 520px;

        .relatedList {
          display: flex;
          margin-bottom: 14px;
          cursor: pointer;

          img {
            width: 160px;
            height: 90px;
            background: #364d79;
            border-radius: 6px;
            margin-right: 14px;
          }

          div {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 0;

            h5 {
              font-size: 16px;
              color: #000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            p {
              display: flex;
              flex-wrap: wrap;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;

              b {
                font-size: 14px;
                color: #333;
                font-weight: normal;
                margin-right: 10px;
              }
            }


            i {
              font-size: 12px;
              color: #708aa2;
              margin-top: auto;
            }
          }
        }
      }
    }
  }
  /* 相关推荐分页按钮样式 */
  .pagination {
    font-size: 30px;
    display: flex;
    justify-content: center;
    color: rgba(102, 102, 102, 0.6);

    span{
      margin:0 10px;
      cursor: no-drop;

      &.active{
        color:rgba(5, 129, 206, 0.6);
        cursor: pointer;
      }
    }
  }
</style>
